import { useEffect, useState } from "react";
import "./style.css";
import SaveResumeProgressButton from "../../Components/SaveResumeProgressButton";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import { useHeader } from "../../Providers/HeaderContextProvider";
import { getPreferredVideo } from "../../Utils/media";

function AssessmentSaveProgress() {
  const [searchParams] = useSearchParams();
  const { menu } = useParams();
  const { setHeaderContent } = useHeader();
  const categoryGroup = searchParams.get("categoryGroup");
  // const type = "save";
  const [type, settype] = useState(
    menu === "survey"
      ? "save"
      : menu === "assessmentCompleted"
      ? "assessmentCompleted"
      : "assessment"
  );

  const navigate = useNavigate();

  useEffect(() => {
    setHeaderContent(true);
  }, []);

  const onContinueClick = () => {
    if (type === "assessmentCompleted") {
      if (categoryGroup === "fourth") {
        navigate("/story");
      } else {
        navigate("/onboarding");
      }
    } else {
      if (menu === "survey") navigate("/survey");
      else navigate("/onboarding");
    }
    // menu === "survey" ? navigate("/survey") : navigate("/assessment");
  };

  return (
    // <div className={"save-progress-hero-container"}>
    <div>
        <div className="supressed-bg">
          <div className={"save-progress-content"}>
            <div>
              {/* <img
              src={progress}
              alt={"progress"}
              className={"save-progress-img"}
            /> */}{" "}
              <video
                autoPlay
                loop
                muted
                playsInline
                webkit-playsinline="true"
                className="relationship-gif"
                src={getPreferredVideo(
                  `${process.env.REACT_APP_STATIC_CONTENT}ui-components/Sphere_Loader.webm`,
                  `${process.env.REACT_APP_STATIC_CONTENT}ui-components/sphere-ios.mov`
                )}
              />
            </div>
            <div className={"save-progress-txt"}>
              {type === "start"
                ? ""
                : type === "save"
                ? "Progress saved"
                : type === "assessment"
                ? "Progress saved"
                : type === "assessmentCompleted"
                ? "Congratulations!"
                : "Welcome back"}
            </div>
            <div className={"save-progress-support-txt"}>
              {type === "start"
                ? "This will take about 40 minutes, but you can do it in 4  parts, and finish it whenever you want."
                : type === "save"
                ? "Come back any time to finish taking your survey."
                : type === "assessment"
                ? "Come back any time to finish taking your assessment."
                : type === "assessmentCompleted"
                ? `You finished the ${
                    categoryGroup || "first"
                  } part of your Aris Portrait.`
                : "Ready to pick up where you left off?"}
            </div>

            {type === "assessmentCompleted" && (
              <div className={"save-progress-support-txt-2"}>
                Let me tell you about how you are wired.
              </div>
            )}
            <SaveResumeProgressButton
              txt={
                type === "start"
                  ? "Let's Go!"
                  : type === "save"
                  ? "Resume survey"
                  : type === "assessmentCompleted"
                  ? "Let's Go!"
                  : "Resume Aris Assessment"
              }
              onClickButton={onContinueClick}
            />

            {type !== "assessmentCompleted" && (
              <div
                className={"save-progress-mini-txt"}
                onClick={() => navigate("/about-aris")}
              >
                {type === "save"
                  ? "Tell me more about Prism"
                  : "Tell me more about Aris"}
              </div>
            )}
          </div>
        </div>
    </div>
  );
}

export default AssessmentSaveProgress;
